import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://quizzler-production.up.railway.app';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('quizzler_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Admin Auth API
export const adminAuthAPI = {
  login: (email, password) => api.post('/api/admin/login', { email, password }),
  getMe: () => api.get('/api/admin/me'),
};

// Hosts Management API
export const hostsAPI = {
  getAll: () => api.get('/api/admin/hosts'),
  getOne: (hostId) => api.get(`/api/admin/hosts/${hostId}`),
  update: (hostId, data) => api.put(`/api/admin/hosts/${hostId}`, data),
  delete: (hostId) => api.delete(`/api/admin/hosts/${hostId}`),
  resetPassword: (hostId) => api.post(`/api/admin/hosts/${hostId}/reset-password`),
};

// Templates Management API
export const adminTemplatesAPI = {
  getAll: () => api.get('/api/game-templates'),
  getOne: (templateId) => api.get(`/api/game-templates/${templateId}`),
  create: (data) => api.post('/api/admin/templates', data),
  update: (templateId, data) => api.put(`/api/admin/templates/${templateId}`, data),
  delete: (templateId) => api.delete(`/api/admin/templates/${templateId}`),
  getStats: (templateId) => api.get(`/api/admin/templates/${templateId}/stats`),
};

// Analytics API
export const analyticsAPI = {
  getOverview: () => api.get('/api/admin/analytics/overview'),
  getHostStats: () => api.get('/api/admin/analytics/hosts'),
  getRevenue: () => api.get('/api/admin/analytics/revenue'),
};

// Subscriptions Management API
export const adminSubscriptionsAPI = {
  getAll: () => api.get('/api/admin/subscriptions'),
  getOne: (subId) => api.get(`/api/admin/subscriptions/${subId}`),
  update: (subId, data) => api.put(`/api/admin/subscriptions/${subId}`, data),
  getTiers: () => api.get('/api/subscription-tiers'),
};

// Championships API
export const championshipsAPI = {
  getLeaderboard: (params) => api.get('/api/admin/championships/leaderboard', { params }),
  getByRegion: (region) => api.get(`/api/admin/championships/by-region/${region}`),
  exportData: () => api.get('/api/admin/championships/export'),
};

// Game History API (admin view - all games)
export const adminHistoryAPI = {
  getAll: (limit = 50, offset = 0) => api.get(`/api/admin/game-history?limit=${limit}&offset=${offset}`),
  getByHost: (hostId) => api.get(`/api/admin/game-history/host/${hostId}`),
};

export default api;
